import BitOrigin from '@/assets/image/useCases/privateCredit/BitOrigin.png'
import Blockware from '@/assets/image/useCases/privateCredit/Blockware.png'
import Antpool from '@/assets/image/useCases/privateCredit/Antpool.png'
import Circle from '@/assets/image/useCases/privateCredit/Circle.png'
import Tether from '@/assets/image/useCases/privateCredit/Tether.png'
import USDQ from '@/assets/image/useCases/privateCredit/USDQ.png'

import ContentImg1 from '@/assets/image/useCases/privateCredit/logo1.png'
import ContentImg2 from '@/assets/image/useCases/privateCredit/logo2.png'
import ContentImg3 from '@/assets/image/useCases/privateCredit/logo3.png'
import ContentImg4 from '@/assets/image/useCases/privateCredit/logo4.png'
import './index.scss'
import { useMediaQuery } from 'react-responsive';
const trustList = [
  {
    logo: BitOrigin,
  }, {
    logo: Blockware,
  }, {
    logo: Antpool,
  }, {
    logo: Circle,
  }, {
    logo: Tether,
  }, {
    logo: USDQ,
  }
]

const PrivateCreditContent = () => {
  const isDesktop = useMediaQuery({ minWidth: 769 });

  return (
    <div className={`private-credit-list text-[#fff]`}>
      {
        isDesktop?(
          <>
            <div className={`private-credit-list-item`}>
              <div className={`w-1340 flex items-center trust-wrap private-credit-list-item-content`}>
                <div className={`trust-title w-[268px] text-[18px] text-center leading-[60px] h-[60px]`}>Trusted by
                </div>
                <div className={`trust-list flex h-[60px] items-center`}>
                  {
                    trustList.map((item, i) => (
                      <div key={i} className={`trust-list-item flex items-center ml-[40px]`}>
                        <img src={item.logo} className={`h-[18px]`} />
                      </div>
                    ))
                  }
                </div>
              </div>
            </div>
            <div className={`private-credit-list-item`}>
              <div className={`w-1340 flex content-wrap private-credit-list-item-content`}>
                <div style={{ borderRight: '1px solid #434343' }}
                     className={`flex-1 content-item pl-[90px] pr-[102px]`}>
                  <img src={ContentImg1} className={`content-item-img`} />
                  <div className={`content-item-title mb-[10px]`}>Borrow Without Selling</div>
                  <div className={`content-item-desc`}>
                    Access stablecoin credit without needing to sell your underlying assets, helping you avoid
                    unnecessary
                    taxable disposals.
                  </div>
                </div>
                <div className={`flex-1 content-item pl-[90px] pr-[102px]`}>
                  <img src={ContentImg2} className={`content-item-img`} />
                  <div className={`content-item-title mb-[10px]`}>Keep The Upside</div>
                  <div className={`content-item-desc`}>
                    Collateral stays in your control throughout the loan term, so you retain future appreciation.
                  </div>
                </div>
              </div>
            </div>
            <div className={`private-credit-list-item`}>
              <div className={`w-1340 flex content-wrap private-credit-list-item-content`}>
                <div style={{ borderRight: '1px solid #434343' }}
                     className={`flex-1 content-item pl-[90px] pr-[102px]`}>
                  <img src={ContentImg3} className={`content-item-img`} />
                  <div className={`content-item-title mb-[10px]`}>Global Liquidity</div>
                  <div className={`content-item-desc`}>
                    Tap on-chain capital markets for deeper, more competitive liquidity beyond local lending
                    constraints.
                  </div>
                </div>
                <div className={`flex-1 content-item pl-[90px] pr-[102px]`}>
                  <img src={ContentImg4} className={`content-item-img`} />
                  <div className={`content-item-title mb-[10px]`}>Custody Preserved</div>
                  <div className={`content-item-desc`}>
                    You maintain ownership and control of your assets, with custody only transferring if repayment
                    obligations
                    are not met.
                  </div>
                </div>
              </div>
            </div>
            <div className={`private-credit-list-item`}>
              <div className={`w-1340 p-[56px_52px_56px_90px] flex text-[32px] items-center private-credit-list-title private-credit-list-item-content`}>
                Trustless credit for humans and AI agents, secured by self-custodied blue-chip digital assets, starting
                with BTC
              </div>
            </div>
            <div className={`private-credit-list-item`}>
              <div className={`w-1340 flex content-wrap private-credit-list-item-content`}>
                <iframe width="100%" height="428" src="https://www.youtube.com/embed/G4mTIG6kkXM?si=6HBghIZ6wv4MeC_L"
                        title="YouTube video player" frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className={`private-credit-list-item`}>
              <div className={`w-1340 trust-wrap private-credit-list-item-content`}>
                <div className={`trust-title text-[18px] text-center leading-[60px] h-[60px]`}>Trusted by
                </div>
                <div className={`trust-list flex flex-wrap items-center justify-around p-[0_20px_20px]`}>
                {
                    trustList.map((item, i) => (
                      <div key={i} className={`trust-list-item flex items-center m-[10px]`}>
                        <img src={item.logo} className={`h-[18px]`} />
                      </div>
                    ))
                  }
                </div>
              </div>
            </div>
            <div className={`private-credit-list-item`}>
              <div className={`w-1340 content-wrap private-credit-list-item-content`}>
                <div style={{ borderBottom: '1px solid #434343' }}
                     className={`flex-1 content-item p-[20px]`} style={{ paddingTop: '20px' }}>
                  <img src={ContentImg1} className={`content-item-img`} />
                  <div className={`content-item-title mb-[10px]`}>Borrow Without Selling</div>
                  <div className={`content-item-desc`}>
                    Access stablecoin credit without needing to sell your underlying assets, helping you avoid
                    unnecessary
                    taxable disposals.
                  </div>
                </div>
                <div className={`flex-1 content-item p-[20px]`} style={{ paddingTop: '20px' }}>
                  <img src={ContentImg2} className={`content-item-img`} />
                  <div className={`content-item-title mb-[10px]`}>Keep The Upside</div>
                  <div className={`content-item-desc`}>
                    Collateral stays in your control throughout the loan term, so you retain future appreciation.
                  </div>
                </div>
              </div>
            </div>
            <div className={`private-credit-list-item`}>
              <div className={`w-1340 content-wrap private-credit-list-item-content`}>
                <div style={{ borderBottom: '1px solid #434343' }}
                     className={`flex-1 content-item p-[20px]`} style={{ paddingTop: '20px' }}>
                  <img src={ContentImg3} className={`content-item-img`} />
                  <div className={`content-item-title mb-[10px]`}>Global Liquidity</div>
                  <div className={`content-item-desc`}>
                    Tap on-chain capital markets for deeper, more competitive liquidity beyond local lending
                    constraints.
                  </div>
                </div>
                <div className={`flex-1 content-item p-[20px]`} style={{ paddingTop: '20px' }}>
                  <img src={ContentImg4} className={`content-item-img`} />
                  <div className={`content-item-title mb-[10px]`}>Custody Preserved</div>
                  <div className={`content-item-desc`}>
                    You maintain ownership and control of your assets, with custody only transferring if repayment
                    obligations
                    are not met.
                  </div>
                </div>
              </div>
            </div>
            <div className={`private-credit-list-item`}>
              <div style={{ padding: '20px', fontSize: '20px' }}
                   className={`w-1340 flex items-center private-credit-list-title private-credit-list-item-content`}>
                Trustless credit for humans and AI agents, secured by self-custodied blue-chip digital assets, starting with
                BTC
              </div>
            </div>

            <div className={`private-credit-list-item`}>
              <div className={`w-1340 flex content-wrap private-credit-list-item-content`}>
                <iframe width="100%" height="300" src="https://www.youtube.com/embed/G4mTIG6kkXM?si=6HBghIZ6wv4MeC_L"
                        title="YouTube video player" frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
              </div>
            </div>
          </>
        )
      }

    </div>
  )
}

export default PrivateCreditContent